// extracted by mini-css-extract-plugin
export var header = "_tc-1";
export var maskBottom = "_tc-6";
export var maskMiddle = "_tc-7";
export var maskTop = "_tc-5";
export var root = "_tc-0";
export var scrollDownButton = "_tc-3";
export var scrollDownButtonHidden = "_tc-4";
export var viewport = "_tc-2";